import {
    Dashboard as DashboardIcon,
    Notifications as NotificationsIcon,
    Settings as SettingsIcon,
} from "@mui/icons-material";
import {
    Box,
    Button,
    keyframes,
    Paper,
    Slider,
    styled,
    TextField,
    Typography,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {SmmticketCampaingsTable} from "./SmmticketCampaingsTable";

// Animation keyframes
const slideIn = keyframes`
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const SmmTickets = ({data, campaings,getData,currentPage,setCurrentPage,rowsPerPage,setRowsPerPage}) => {

    return (
        <>
            <Box sx={{p: 3, maxWidth: 800, margin: "0 auto"}}>
                <Box sx={{textAlign: "center", mb: 4}}>
                    <SettingsIcon sx={{fontSize: 40, mb: 1}}/>
                    <Typography variant="h4" gutterBottom>
                        Smmticket Tickets
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        Show the Tickets of the smmticket
                    </Typography>
                </Box>


            </Box>
            <SmmticketCampaingsTable
                campaings={campaings}
                getData={getData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
            />
        </>

    );
};
export default SmmTickets;
